export const resetevent = {
    eventId:0,
    //eventseason:null,
    eventname:'',
    startdate:'',
    enddate:'',
    eventnumberofdays:0,
    eventaddress: '',
    centercertnumber:null,
    centername: '',
    eventcity: '',
    eventstate: '',
    eventzipcode: '',
    eventcountry: 'US',
    status: ''
  };

  
export const resetdirector = {
    memberidprefix: '',
    memberidsuffix: '',
    directorname: '',
    eventemail: '',
    directorssoemail: '',
    directorphone: '',
    directorcountry: 'US',
    directoraddress1: '',
    directoraddress2: '',
    directorcity: '',
    directorstate: '',
    directorzipcode: ''
  };

  const reseteventdetails = {
    eventType:'',
    numberOfGames:null,
    numberOfWeeks:null,
    certificationNumber:null,
  };

  const reseteventlaneconditions = {
    dailyOilRatios:'false',
    weeklyOilRatios:'false',
    oilRatio:[{
      day:1,
      ratio:null,
      condition:'1',
    }],
  };

  const resetsetup = {
    advancerPolicy:'0',
    includeEnhancedAdvancerRatio:'false',
    premierEvent:'false',
    useMajorFraction:'false',
    offersScholarship:'false',
    smartProviderId:'',
  };

  const resetpayment = {
    name:'',
    ccnumber:'',
    expiry:'',
    cvc:'',
    depositPaidOn:null,
    depositAmount:null,
    depositConfirmation:null
  };

  const resetwizard = {
    step:1,
    lastStepCompleted:1,
    savingComponentState:false,
    componentStateSaved:false,
  };

  const resetrules= {
    currentWizardStep:1,
    rulesApproved:false, 
    rulesApprovedOn:null,
    rulesUploadedOn:null,
    uploadingRules:false,
    successfileUpload:false,
  };
  
export default {
    eventRetrieved:false,  
    inWizardMode:false,
    fetchingevent:false,
    eventseason:'',
    ...resetevent,
    ...resetdirector,
    ...reseteventdetails,
    ...reseteventlaneconditions,
    ...resetsetup,
    ...resetpayment,
    ...resetwizard,
    ...resetrules,
    // seasons:[],
    searching:false,
    pendinguploads:[],
    hasDirectorRole:true,
    hasAdminRole:false,
}


// WEBPACK FOOTER //
// ./src/utils/constants/reseteventfields.js